import React from 'react'
import { withPrefix, Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import { StaticImage } from "gatsby-plugin-image"
// import * as styles from "../styles/navbar.module.scss"
import '../styles/navbar.scss';

const Navbar = () => {

  return (
    <>
      <Helmet>
        <script src={withPrefix('navbar_mobile.js')} type="text/javascript" />
      </Helmet>
      
      <nav className="nav" id="nav">
        <div className="nav_mobile" id="nav_mobile">
          <button id="burger_container" className="burger_container">
            <div className="burger">
              <div className="topbar"></div>
              <div className="btmbar"></div>
            </div>
          </button>
          <div className="block_links">
            <Link className="nav_logo_mark_mobile" to="/">
              <StaticImage 
                className="nav_logo_mark" 
                alt="Go to Home Page" 
                src="../images/verve_mark.png" 
                placeholder="tracedSVG"
              />
            </Link>
          </div>
          <ul className="menu">
            <li>
              <Link to="/our-kombucha" activeClassName="active">Our Kombucha</Link>
            </li>
            <li>
              <Link to="/locate" activeClassName="active">Locate</Link>
            </li>
            <li>
              <Link to="/wholesale" activeClassName="active">Wholesale</Link>
            </li>
            <li>
              <Link to="/our-story" activeClassName="active">Our Story</Link>
            </li>
            <li>
              <Link to="/contact" activeClassName="active">Contact</Link>
            </li>
            <li>
              <Link to="/private-events" activeClassName="active">Private Events</Link>
            </li>
          </ul>
        </div>
        {/* Desktop Navigation Begins */}
        <div className="nav_desktop" id="nav_desktop">
          <ul className="menu">
            <li>
              <Link to="/our-kombucha" activeClassName="active">Our Kombucha</Link>
            </li>
            <li>
              <Link to="/locate" activeClassName="active">Locate</Link>
            </li>
            <li>
              <Link to="/wholesale" activeClassName="active">Wholesale</Link>
            </li>
            <li>
              <Link to="/">
                <StaticImage 
                  className="nav_logo_mark" 
                  alt="Go to Home Page" 
                  src="../images/verve_mark.png" 
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li>
              <Link to="/our-story" activeClassName="active">Our Story</Link>
            </li>
            <li>
              <Link to="/contact" activeClassName="active">Contact</Link>
            </li>
            <li>
              <Link to="/private-events" activeClassName="active">Private Events</Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  )
}

export default Navbar